import { waLink } from "@/data/site";

// Botón flotante de WhatsApp (círculo fijo abajo a la derecha)
export const WhatsAppFab = () => {
  return (
    <a
      href={waLink("Hola Lu Design, me gustaría platicar sobre un proyecto.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-fab"
      className="group fixed bottom-6 right-6 z-50 flex items-center"
    >
      {/* Etiqueta al pasar el cursor */}
      <span className="pointer-events-none mr-3 hidden md:block max-w-0 overflow-hidden whitespace-nowrap rounded-full bg-plum py-2 text-xs uppercase tracking-[0.15em] text-ivory opacity-0 transition-[max-width,opacity,padding] duration-500 ease-out group-hover:max-w-xs group-hover:px-4 group-hover:opacity-100">
        ¿Hablamos?
      </span>

      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-plum/30 transition-transform duration-500 ease-out group-hover:scale-110">
        {/* Pulso sutil */}
        <span
          className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
          style={{ animationDuration: "2.4s" }}
        />
        <i className="fa-brands fa-whatsapp relative text-2xl" />
      </span>
    </a>
  );
};

export default WhatsAppFab;
